/** Shimmer gradient matching Figma Paxton Neutral ramp (200 → 100 → 50-ish → 200) */
const SHIMMER_GRADIENT = 'linear-gradient(90deg, rgb(240, 235, 226) 0%, rgb(246, 243, 237) 25%, rgb(249, 247, 244) 65%, rgb(240, 235, 226) 100%)'

export interface LoadingSkeletonProps {
  /** Width of the skeleton (e.g. '50%', '100%', '15%', or a number for px). */
  width: string | number
  /** Height of the line, matching the line-height of the content being loaded. Defaults to 1.25rem. */
  lineHeight?: string | number
}

/**
 * A single skeleton line with shimmer animation. Use multiple instances to build the layout you need.
 */
export function LoadingSkeleton({ width, lineHeight = '1.25rem' }: LoadingSkeletonProps) {
  const heightStyle = typeof lineHeight === 'number' ? `${lineHeight}px` : lineHeight
  const widthStyle = typeof width === 'number' ? `${width}px` : width

  return (
    <span
      data-ds-component="LoadingSkeleton"
      className="inline-block overflow-hidden rounded-sm bg-brand-neutral-200 relative"
      style={{ height: heightStyle, width: widthStyle }}
      role="status"
      aria-label="Loading"
    >
      <span className="absolute inset-y-0 left-0 w-1/2 animate-skeleton-shimmer rounded-sm" style={{ backgroundImage: SHIMMER_GRADIENT }} aria-hidden />
    </span>
  )
}
